import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"


export function Contact(){

  return(
    <Container id="contacto">
      <header>
        <h2>¿Hablamos?</h2>
        <p>Puedes ponerte en contacto conmigo por email, responderé en menos de 48h</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:cristinajover.works@gmail.com">cristinajover.works@gmail.com</a>
        </div>
      </div>
    </Container>
  )
}
